/*
Delivery    Global Maternity Care    59400    Z34.80    O80    Z39.2    Z39.1    Z3A.40
Delivery    Vaginal Delivery + PP Care    59410    O80    Z39.2    Z39.1        Z3A.40
Delivery    Vaginal Delivery    59409    O80                Z3A.40
Delivery    Cesarean Global Maternity Care    59510    Z34.80    O82    Z39.2    Z39.1    Z3A.40
Delivery    Cesarean Delivery    59514    O82                Z3A.40

Antepartum    Prenatal Visits, 4-6    59425    Z34.80    Z33.1
Antepartum    Prenatal Visits, 7 or more    59426    Z34.80    Z33.1
Antepartum    New Patient Home Visit, 1hr    99344    Z34.80    Z33.1
Antepartum    Established Patient Home 40+ min    99349    Z34.80    Z33.1
Antepartum    New Patient Office Visit, 1 hr    99205    Z34.80    Z33.1
Antepartum    New Patient Office Visit, 45-60 min    99204    Z34.80    Z33.1
Antepartum    Established Patient Office Visit 40-54 min    99215    Z34.80    Z33.1
Antepartum    Consultation / 60 min    99404    Z34.80    Z33.1
Fetal nonstress test        59025        Z33.1

Postpartum    Postpartum Visits    59430    Z39.2    Z39.1
Postpartum    Established Patient Home Visit 40+min    99349    Z39.2    Z39.1
Postpartum    Established Patient Office Visit 40-54min    99215    Z39.2    Z39.1

Fetal non-stress tes
Labor    Home Labor, 1st hour    99350    Z34.80    Z33.1
Labor    Home Labor, 2nd hour    99291    Z34.80    Z33.1
Labor    Home Labor, 30 minutes    99292    Z34.80    Z33.1    O63.9
Labor    Home Labor, 15 minutes    99417    Z34.80    Z33.1    O63.9
Labor    Hospital Admission (1st hr of Labor)    99223    Z34.80    Z33.1
Labor    Hospital Labor, 15 minutes    99418    Z34.80    Z33.1    O63.9
Labor    Discharge, Final exam in Hospital    99217    Z39.2

Newborn
Newborn    Initial Newborn Care    99461    Z38.1    Z00.110    Z37.0
Newborn    New Patient Home Visit, 1hr    99344    Z38.1    Z00.110
Newborn    New Patient Home Visit, 30+ minutes    99342        Z00.110 OR Z00.111
Newborn    Established Patient Home Visit    99349    Z38.1    Z00.110    Z00.111
Newborn    Established patient / newborn    99391        Z00.110 or Z00.111
Newborn    Birth Assistant    99464    Z00.110
Newborn    Newborn Resuscitation    99465    P92.6

Lactation    Lactation Class / Breastfeeding support    S9443    Z39.1

GYN    New Patient GYN Visit, 18-39 yrs    99385    Z01.419    Z30.0
GYN    Established Patient GYN Visit, 18-39 yrs    99395    Z01.419
GYN    New Patient GYN Visit, 40-64 yrs    99386    Z01.419    Z30.0
GYN    Established Patient GYN Visit, 40-64 yrs    99396    Z01.419
GYN    IUD Placement    58300    Z30.430
GYN    Annual GYN Exam, Established Patient    S0612    Z01.419
GYN    Pap Smear    Q0091    Z11.51

*/

import { ICD10, ICD10Group } from '../../types/providers'

// ─── LEGACY / BILLING-SPECIFIC CODES ─────────────────────────────────────────

export const o36_0131: ICD10 = {
  code: 'O36.0131',
  description: 'Administered upon delivery of newborn',
}

export const o36_0191: ICD10 = {
  code: 'O36.0191',
  description: '(administered at 28 weeks)',
}

export const o63_9: ICD10 = {
  code: 'O63.9',
  description: 'Unspecified complication of labor and delivery.',
}

export const o80: ICD10 = {
  code: 'O80',
  description: 'Encounter for full-term uncomplicated delivery.',
}

export const o82: ICD10 = {
  code: 'O82',
  description: 'Encounter for cesarean delivery without indication.',
}

export const p92_6: ICD10 = {
  code: 'P92.6',
  description: 'Failure to thrive in newborn.',
}

export const z00_110: ICD10 = {
  code: 'Z00.110',
  description: 'Health examination for newborn under 8 days old',
}

export const z00_111: ICD10 = {
  code: 'Z00.111',
  description: 'Health examination for newborn 8 to 28 days old',
}

export const z01_419: ICD10 = {
  code: 'Z01.419',
  description:
    'Encounter for gynecological examination (general) (routine) without abnormal findings.',
}

export const z11_51: ICD10 = {
  code: 'Z11.51',
  description: 'Encounter for screening for human papillomavirus (HPV).',
  keywords: ['HPV', 'HPV screening', 'Pap'],
}

export const z30_0: ICD10 = {
  code: 'Z30.0',
  description: 'Encounter for general counseling and advice on contraception.',
}

export const z30_430: ICD10 = {
  code: 'Z30.430',
  description: 'Encounter for insertion of intrauterine contraceptive device.',
}

export const z33_1: ICD10 = {
  code: 'Z33.1',
  description: 'Pregnant state, incidental.',
}

export const z34_80: ICD10 = {
  code: 'Z34.80',
  description:
    'Encounter for supervision of other normal pregnancy, unspecified trimester(80), 1st trimester (81), 2nd trimester (82), 3rd trimester (83).',
  keywords: ['prenatal', 'routine', 'supervision', 'normal pregnancy'],
}

export const z37_0: ICD10 = {
  code: 'Z37.0',
  description: 'Single liveborn infant, born in hospital.',
}

export const z37_2: ICD10 = {
  code: 'Z37.2',
  description: 'Twin birth, mate liveborn, born in hospital.',
}

export const z38_1: ICD10 = {
  code: 'Z38.1',
  description: 'Single liveborn infant, born outside hospital.',
}

export const z38_30: ICD10 = {
  code: 'Z38.30',
  description: 'Twin liveborn infant, delivered vaginally.',
}

export const z39_2: ICD10 = {
  code: 'Z39.2',
  description: 'Encounter for routine postpartum follow-up.',
  keywords: ['postpartum visit', '6 week visit', 'follow-up after delivery'],
  notes: 'Auto-suggest at postpartum visit type.',
}

export const z39_1: ICD10 = {
  code: 'Z39.1',
  description:
    'Encounter for care and examination of lactating mother, encounter for supervision of lactation.',
  keywords: ['breastfeeding visit', 'lactation', 'nursing visit'],
  notes: 'Use at routine postpartum breastfeeding-focused visit.',
}

export const z3a_40: ICD10 = {
  code: 'Z3A.40',
  description:
    '40 weeks gestation of pregnancy. "Z3A." -then add the number of weeks the patient is at the time of delivery.',
  keywords: ['weeks pregnant', 'gestational age', 'how many weeks'],
  notes:
    'Always required. Auto-add based on GA in chart. Range Z3A.06–Z3A.42. Display as "Gestational Age: [X] weeks".',
}

// ─── CATEGORY 1 — Routine Pregnancy Supervision ──────────────────────────────

export const z34_01: ICD10 = {
  code: 'Z34.01',
  description: 'Routine prenatal care — first trimester.',
  keywords: [
    'first trimester',
    'prenatal',
    'routine',
    'supervision',
    'normal pregnancy',
    'weeks 1-13',
  ],
  notes: 'Auto-suggest on Routine visit if GA <14w.',
}

export const z34_02: ICD10 = {
  code: 'Z34.02',
  description: 'Routine prenatal care — second trimester.',
  keywords: [
    'second trimester',
    'prenatal',
    'routine',
    'supervision',
    'normal pregnancy',
    'weeks 14-27',
  ],
  notes: 'Auto-suggest on Routine visit if GA 14–27w.',
}

export const z34_03: ICD10 = {
  code: 'Z34.03',
  description: 'Routine prenatal care — third trimester.',
  keywords: [
    'third trimester',
    'prenatal',
    'routine',
    'supervision',
    'normal pregnancy',
    'weeks 28+',
  ],
  notes: 'Auto-suggest on Routine visit if GA ≥28w.',
}

export const z34_00: ICD10 = {
  code: 'Z34.00',
  description: 'Routine prenatal care — trimester not specified.',
  keywords: ['prenatal', 'routine', 'supervision', 'normal pregnancy'],
  notes: 'Use when GA not established or for coding flexibility.',
}

export const z09: ICD10 = {
  code: 'Z09',
  description: 'Follow-up care after completed treatment.',
  keywords: ['follow-up', 'completed treatment'],
  notes: 'For post-treatment follow-up visits.',
}

export const z34_90: ICD10 = {
  code: 'Z34.90',
  description: 'Encounter for supervision of normal pregnancy, unspecified trimester.',
  keywords: ['prenatal', 'routine', 'normal', 'check-up'],
  notes: 'Broad catch-all if trimester unclear.',
}

// ─── CATEGORY 2 — Hypertensive Disorders of Pregnancy ───────────────────────

export const o13_1: ICD10 = {
  code: 'O13.1',
  description: 'Elevated blood pressure — first trimester.',
  keywords: ['high blood pressure', 'HTN', 'hypertension', 'first trimester'],
  notes: 'Auto-suggest if BP ≥140/90 flagged AND GA <14w.',
}

export const o13_2: ICD10 = {
  code: 'O13.2',
  description: 'Elevated blood pressure — second trimester.',
  keywords: ['high blood pressure', 'HTN', 'hypertension', 'second trimester'],
  notes: 'Auto-suggest if BP ≥140/90 flagged AND GA 14–27w.',
}

export const o13_3: ICD10 = {
  code: 'O13.3',
  description: 'Elevated blood pressure — third trimester.',
  keywords: ['high blood pressure', 'HTN', 'hypertension', 'third trimester'],
  notes: 'Auto-suggest if BP ≥140/90 flagged AND GA ≥28w.',
}

export const o14_02: ICD10 = {
  code: 'O14.02',
  description: 'Mild to moderate preeclampsia — second trimester.',
  keywords: [
    'preeclampsia',
    'pre-eclampsia',
    'PIH',
    'protein urine high blood pressure',
    'second trimester',
  ],
}

export const o14_03: ICD10 = {
  code: 'O14.03',
  description: 'Mild to moderate preeclampsia — third trimester.',
  keywords: [
    'preeclampsia',
    'pre-eclampsia',
    'PIH',
    'protein urine high blood pressure',
    'third trimester',
  ],
}

export const o14_12: ICD10 = {
  code: 'O14.12',
  description: 'Severe preeclampsia — second trimester.',
  keywords: ['severe preeclampsia', 'severe PIH', 'second trimester'],
}

export const o14_13: ICD10 = {
  code: 'O14.13',
  description: 'Severe preeclampsia — third trimester.',
  keywords: ['severe preeclampsia', 'severe PIH', 'third trimester'],
}

export const o14_22: ICD10 = {
  code: 'O14.22',
  description: 'HELLP syndrome — second trimester.',
  keywords: ['HELLP', 'hemolysis elevated liver', 'low platelets', 'second trimester'],
}

export const o14_23: ICD10 = {
  code: 'O14.23',
  description: 'HELLP syndrome — third trimester.',
  keywords: ['HELLP', 'hemolysis elevated liver', 'low platelets', 'third trimester'],
}

export const o10_012: ICD10 = {
  code: 'O10.012',
  description: 'Pre-existing hypertension complicating pregnancy — second trimester.',
  keywords: ['chronic hypertension', 'pre-existing high blood pressure', 'second trimester'],
}

export const o10_013: ICD10 = {
  code: 'O10.013',
  description: 'Pre-existing hypertension complicating pregnancy — third trimester.',
  keywords: ['chronic hypertension', 'pre-existing high blood pressure', 'third trimester'],
}

export const o16_1: ICD10 = {
  code: 'O16.1',
  description: 'Unspecified maternal hypertension — first trimester.',
  keywords: ['hypertension', 'high blood pressure', 'first trimester', 'unspecified'],
}

export const o16_2: ICD10 = {
  code: 'O16.2',
  description: 'Unspecified maternal hypertension — second trimester.',
  keywords: ['hypertension', 'high blood pressure', 'second trimester', 'unspecified'],
}

export const o16_3: ICD10 = {
  code: 'O16.3',
  description: 'Unspecified maternal hypertension — third trimester.',
  keywords: ['hypertension', 'high blood pressure', 'third trimester', 'unspecified'],
}

// ─── CATEGORY 3 — Diabetes in Pregnancy ─────────────────────────────────────

export const o24_010: ICD10 = {
  code: 'O24.010',
  description: 'Pre-existing type 1 diabetes — first trimester.',
  keywords: ['type 1 diabetes', 'insulin dependent diabetes', 'T1DM', 'first trimester'],
}

export const o24_012: ICD10 = {
  code: 'O24.012',
  description: 'Pre-existing type 1 diabetes — second trimester.',
  keywords: ['type 1 diabetes', 'insulin dependent diabetes', 'T1DM', 'second trimester'],
}

export const o24_013: ICD10 = {
  code: 'O24.013',
  description: 'Pre-existing type 1 diabetes — third trimester.',
  keywords: ['type 1 diabetes', 'insulin dependent diabetes', 'T1DM', 'third trimester'],
}

export const o24_110: ICD10 = {
  code: 'O24.110',
  description: 'Pre-existing type 2 diabetes — first trimester.',
  keywords: ['type 2 diabetes', 'T2DM', 'first trimester'],
}

export const o24_112: ICD10 = {
  code: 'O24.112',
  description: 'Pre-existing type 2 diabetes — second trimester.',
  keywords: ['type 2 diabetes', 'T2DM', 'second trimester'],
}

export const o24_113: ICD10 = {
  code: 'O24.113',
  description: 'Pre-existing type 2 diabetes — third trimester.',
  keywords: ['type 2 diabetes', 'T2DM', 'third trimester'],
}

export const o24_410: ICD10 = {
  code: 'O24.410',
  description: 'Gestational diabetes — diet controlled.',
  keywords: ['GDM', 'gestational diabetes', 'diet controlled', 'A1GDM'],
  notes: 'Auto-suggest when GDM documented and diet-controlled.',
}

export const o24_414: ICD10 = {
  code: 'O24.414',
  description: 'Gestational diabetes — insulin controlled.',
  keywords: ['GDM', 'gestational diabetes', 'insulin', 'A2GDM', 'insulin controlled'],
  notes: 'Auto-suggest when GDM documented and insulin required.',
}

export const o24_415: ICD10 = {
  code: 'O24.415',
  description: 'Gestational diabetes — oral medication controlled.',
  keywords: ['GDM', 'gestational diabetes', 'metformin', 'oral medication', 'A2GDM'],
}

export const z83_3: ICD10 = {
  code: 'Z83.3',
  description: 'Family history of diabetes.',
  keywords: ['family history diabetes', 'diabetes in family'],
  notes: 'Keyword search only — used as secondary code.',
}

// ─── CATEGORY 4 — Mental Health Conditions in Pregnancy ──────────────────────

export const o99_340: ICD10 = {
  code: 'O99.340',
  description: 'Other mental disorders complicating pregnancy — first trimester.',
  keywords: ['anxiety', 'depression', 'mental health', 'mood', 'psychiatric', 'first trimester'],
  notes: 'Auto-suggest when anxiety/depression documented in Non-Routine visit, first trimester.',
}

export const o99_342: ICD10 = {
  code: 'O99.342',
  description: 'Other mental disorders complicating pregnancy — second trimester.',
  keywords: ['anxiety', 'depression', 'mental health', 'mood', 'psychiatric', 'second trimester'],
  notes: 'Auto-suggest when anxiety/depression documented in Non-Routine visit, second trimester.',
}

export const o99_343: ICD10 = {
  code: 'O99.343',
  description: 'Other mental disorders complicating pregnancy — third trimester.',
  keywords: ['anxiety', 'depression', 'mental health', 'mood', 'psychiatric', 'third trimester'],
  notes: 'Auto-suggest when anxiety/depression documented in Non-Routine visit, third trimester.',
}

export const f32_0: ICD10 = {
  code: 'F32.0',
  description: 'Mild depressive episode.',
  keywords: ['depression', 'low mood', 'sad', 'depressed', 'PHQ-9'],
  notes:
    'Use when depression documented outside of Non-Routine OB visit context — provider discretion.',
}

export const f41_1: ICD10 = {
  code: 'F41.1',
  description: 'Generalized anxiety disorder.',
  keywords: ['anxiety', 'GAD', 'worry', 'anxious'],
  notes: 'Provider discretion — use O99.34x for pregnancy context.',
}

export const f43_10: ICD10 = {
  code: 'F43.10',
  description: 'Post-traumatic stress disorder.',
  keywords: ['PTSD', 'trauma', 'post-traumatic'],
}

export const z13_89: ICD10 = {
  code: 'Z13.89',
  description: 'Encounter for screening for other disorder.',
  keywords: ['mental health screening', 'Edinburgh', 'PHQ-9', 'depression screening'],
  notes: 'Use when screening performed at routine visit with no diagnosis.',
}

// ─── CATEGORY 5 — Infections During Pregnancy ────────────────────────────────

export const o23_40: ICD10 = {
  code: 'O23.40',
  description: 'UTI in pregnancy — trimester not specified.',
  keywords: ['UTI', 'urinary tract infection', 'burning', 'frequency', 'dysuria'],
  notes: 'Auto-suggest when UTI/urinary documented in chief complaint or Non-Routine visit.',
}

export const o23_41: ICD10 = {
  code: 'O23.41',
  description: 'UTI in pregnancy — first trimester.',
  keywords: ['UTI', 'urinary tract infection', 'first trimester'],
  notes: 'Auto-suggest based on GA + keyword.',
}

export const o23_42: ICD10 = {
  code: 'O23.42',
  description: 'UTI in pregnancy — second trimester.',
  keywords: ['UTI', 'urinary tract infection', 'second trimester'],
  notes: 'Auto-suggest based on GA + keyword.',
}

export const o23_43: ICD10 = {
  code: 'O23.43',
  description: 'UTI in pregnancy — third trimester.',
  keywords: ['UTI', 'urinary tract infection', 'third trimester'],
  notes: 'Auto-suggest based on GA + keyword.',
}

export const o86_11: ICD10 = {
  code: 'O86.11',
  description: 'Cervicitis following delivery.',
  keywords: ['cervicitis', 'infection after delivery'],
  notes: 'Postpartum context.',
}

export const o23_591: ICD10 = {
  code: 'O23.591',
  description: 'Infection of cervix in pregnancy.',
  keywords: ['cervicitis', 'cervical infection', 'STI'],
}

export const o99_611: ICD10 = {
  code: 'O99.611',
  description: 'Diseases of the digestive system complicating pregnancy — first trimester.',
  keywords: [
    'BV',
    'bacterial vaginosis',
    'vaginal infection',
    'vaginitis',
    'yeast',
    'candida',
    'first trimester',
  ],
  notes: 'Auto-suggest when vaginal infection documented.',
}

export const o23_592: ICD10 = {
  code: 'O23.592',
  description: 'Infection of other part of genital tract in pregnancy.',
  keywords: [
    'vaginal infection',
    'vulvovaginitis',
    'BV',
    'bacterial vaginosis',
    'yeast',
    'candida',
  ],
  notes: 'Covers BV, yeast, vulvovaginitis in pregnancy.',
}

export const b37_3: ICD10 = {
  code: 'B37.3',
  description: 'Candidiasis of vulva and vagina.',
  keywords: ['yeast infection', 'candida', 'thrush'],
  notes: 'Use as secondary code alongside O23.592.',
}

export const n76_0: ICD10 = {
  code: 'N76.0',
  description: 'Acute vaginitis.',
  keywords: ['vaginitis', 'vaginal infection'],
  notes: 'Use when not pregnancy-coded — provider discretion.',
}

export const o98_011: ICD10 = {
  code: 'O98.011',
  description: 'Tuberculosis complicating pregnancy — first trimester.',
  keywords: ['TB', 'tuberculosis'],
}

export const o98_111: ICD10 = {
  code: 'O98.111',
  description: 'Syphilis complicating pregnancy — first trimester.',
  keywords: ['syphilis', 'RPR reactive', 'STI'],
  notes: 'Auto-suggest when RPR reactive documented.',
}

export const o98_311: ICD10 = {
  code: 'O98.311',
  description:
    'Other infections with a predominantly sexual mode of transmission — first trimester.',
  keywords: ['gonorrhea', 'chlamydia', 'STI', 'GC'],
  notes: 'Auto-suggest when GC/Chlamydia positive documented.',
}

export const o98_312: ICD10 = {
  code: 'O98.312',
  description: 'Other infections — second trimester.',
  keywords: ['gonorrhea', 'chlamydia', 'STI', 'second trimester'],
}

export const o98_313: ICD10 = {
  code: 'O98.313',
  description: 'Other infections — third trimester.',
  keywords: ['gonorrhea', 'chlamydia', 'STI', 'third trimester'],
}

export const o99_321: ICD10 = {
  code: 'O99.321',
  description: 'Other infections during pregnancy — first trimester.',
  keywords: [
    'cold',
    'flu',
    'virus',
    'URI',
    'upper respiratory',
    'bronchitis',
    'respiratory illness',
  ],
  notes: 'Auto-suggest when URI/illness documented in Non-Routine visit.',
}

export const o99_322: ICD10 = {
  code: 'O99.322',
  description: 'Other infections during pregnancy — second trimester.',
  keywords: ['cold', 'flu', 'virus', 'URI', 'upper respiratory', 'second trimester'],
}

export const o99_323: ICD10 = {
  code: 'O99.323',
  description: 'Other infections during pregnancy — third trimester.',
  keywords: ['cold', 'flu', 'virus', 'URI', 'upper respiratory', 'third trimester'],
}

export const b34_9: ICD10 = {
  code: 'B34.9',
  description: 'Viral infection, unspecified.',
  keywords: ['virus', 'viral illness', 'COVID', 'influenza', 'flu'],
  notes: 'Use as secondary code with O99.32x.',
}

export const j06_9: ICD10 = {
  code: 'J06.9',
  description: 'Acute upper respiratory infection, unspecified.',
  keywords: ['URI', 'cold', 'cough', 'upper respiratory'],
  notes: 'Use as secondary code when URI documented.',
}

// ─── CATEGORY 6 — GI, Nausea, and Vomiting in Pregnancy ─────────────────────

export const o21_0: ICD10 = {
  code: 'O21.0',
  description: 'Mild hyperemesis gravidarum — before 20 weeks.',
  keywords: ['hyperemesis', 'severe nausea', 'vomiting', 'HG', 'morning sickness severe'],
  notes: 'Auto-suggest when severe nausea/vomiting documented before 20w.',
}

export const o21_1: ICD10 = {
  code: 'O21.1',
  description: 'Hyperemesis gravidarum with metabolic disturbance.',
  keywords: ['hyperemesis', 'nausea vomiting', 'dehydration', 'electrolytes', 'ketones'],
  notes: 'Auto-suggest when dehydration or metabolic disturbance documented with HG.',
}

export const o21_2: ICD10 = {
  code: 'O21.2',
  description: 'Late vomiting of pregnancy — after 20 weeks.',
  keywords: ['nausea', 'vomiting', 'late pregnancy', 'after 20 weeks'],
}

export const o21_9: ICD10 = {
  code: 'O21.9',
  description: 'Vomiting of pregnancy, unspecified.',
  keywords: ['nausea', 'vomiting', 'morning sickness'],
  notes: 'Use when mild/moderate NVP not meeting hyperemesis criteria.',
}

export const o26_611: ICD10 = {
  code: 'O26.611',
  description: 'Liver and biliary tract disorders — first trimester.',
  keywords: ['cholestasis', 'itching', 'liver', 'bile acids', 'ICP', 'first trimester'],
}

export const o26_612: ICD10 = {
  code: 'O26.612',
  description: 'Liver and biliary tract disorders — second trimester.',
  keywords: ['cholestasis', 'itching', 'liver', 'bile acids', 'ICP', 'second trimester'],
  notes: 'Auto-suggest when pruritus + liver concern documented.',
}

export const o26_613: ICD10 = {
  code: 'O26.613',
  description: 'Liver and biliary tract disorders — third trimester.',
  keywords: ['cholestasis', 'itching', 'liver', 'bile acids', 'ICP', 'third trimester'],
  notes: 'Auto-suggest when pruritus + liver concern documented.',
}

export const k21_0: ICD10 = {
  code: 'K21.0',
  description: 'Gastroesophageal reflux with esophagitis.',
  keywords: ['heartburn', 'reflux', 'GERD', 'acid reflux'],
  notes: 'Use as secondary code alongside pregnancy code.',
}

export const k21_9: ICD10 = {
  code: 'K21.9',
  description: 'Gastroesophageal reflux without esophagitis.',
  keywords: ['heartburn', 'reflux', 'GERD', 'acid indigestion'],
}

export const k59_00: ICD10 = {
  code: 'K59.00',
  description: 'Constipation, unspecified.',
  keywords: ['constipation', 'bowel', 'hard stool'],
  notes: 'Secondary code.',
}

// ─── CATEGORY 7 — Musculoskeletal and Skin Conditions in Pregnancy ───────────

export const o26_711: ICD10 = {
  code: 'O26.711',
  description: 'Subluxation of symphysis pubis — first trimester.',
  keywords: [
    'pelvic pain',
    'SPD',
    'symphysis pubis',
    'round ligament',
    'pubic pain',
    'first trimester',
  ],
  notes: 'Auto-suggest when pelvic pain documented.',
}

export const o26_712: ICD10 = {
  code: 'O26.712',
  description: 'Subluxation of symphysis pubis — second trimester.',
  keywords: [
    'pelvic pain',
    'SPD',
    'symphysis pubis',
    'round ligament',
    'pubic pain',
    'second trimester',
  ],
}

export const o26_713: ICD10 = {
  code: 'O26.713',
  description: 'Subluxation of symphysis pubis — third trimester.',
  keywords: [
    'pelvic pain',
    'SPD',
    'symphysis pubis',
    'round ligament',
    'pubic pain',
    'third trimester',
  ],
}

export const m54_5: ICD10 = {
  code: 'M54.5',
  description: 'Low back pain.',
  keywords: ['back pain', 'lumbar pain', 'lower back'],
  notes: 'Secondary code alongside O26.7x for pelvic girdle pain.',
}

export const o26_891: ICD10 = {
  code: 'O26.891',
  description: 'Other specified pregnancy-related conditions — first trimester.',
  keywords: ['musculoskeletal', 'joint pain', 'hip pain', 'sciatica', 'first trimester'],
  notes: 'Catch-all for pregnancy-related musculoskeletal conditions.',
}

export const o26_892: ICD10 = {
  code: 'O26.892',
  description: 'Other specified pregnancy-related conditions — second trimester.',
  keywords: ['musculoskeletal', 'joint pain', 'hip pain', 'sciatica', 'second trimester'],
}

export const o26_893: ICD10 = {
  code: 'O26.893',
  description: 'Other specified pregnancy-related conditions — third trimester.',
  keywords: ['musculoskeletal', 'joint pain', 'hip pain', 'sciatica', 'third trimester'],
}

export const l29_9: ICD10 = {
  code: 'L29.9',
  description: 'Pruritus, unspecified.',
  keywords: ['itching', 'pruritus', 'rash', 'skin'],
  notes: 'Use when itching without cholestasis diagnosis. Evaluate for ICP before using.',
}

export const o26_81: ICD10 = {
  code: 'O26.81',
  description: 'Pregnancy-related exhaustion and fatigue.',
  keywords: ['fatigue', 'exhaustion', 'tired', 'PUPPP'],
  notes: 'PUPPP rash — use with appropriate skin code as secondary.',
}

// ─── CATEGORY 8 — Fetal Concerns and Presentations ───────────────────────────

export const o32_1xx0: ICD10 = {
  code: 'O32.1XX0',
  description: 'Maternal care for breech presentation.',
  keywords: ['breech', 'breech baby', 'footling breech', 'frank breech'],
  notes: 'Auto-suggest when breech documented in visit or ultrasound.',
}

export const o32_2xx0: ICD10 = {
  code: 'O32.2XX0',
  description: 'Maternal care for transverse or oblique lie.',
  keywords: ['transverse', 'oblique', 'lie', 'baby position'],
  notes: 'Auto-suggest when transverse or oblique documented.',
}

export const o32_9xx0: ICD10 = {
  code: 'O32.9XX0',
  description: 'Maternal care for malpresentation, unspecified.',
  keywords: ['malpresentation', 'baby position', 'presentation'],
}

export const o36_0110: ICD10 = {
  code: 'O36.0110',
  description: 'Maternal care for anti-D antibodies — first trimester.',
  keywords: ['Rh sensitization', 'anti-D', 'antibody', 'Rh negative', 'sensitized'],
  notes: 'Auto-suggest when Rh sensitization documented.',
}

export const o36_0120: ICD10 = {
  code: 'O36.0120',
  description: 'Maternal care for anti-D antibodies — second trimester.',
  keywords: [
    'Rh sensitization',
    'anti-D',
    'antibody',
    'Rh negative',
    'sensitized',
    'second trimester',
  ],
}

export const o36_0130: ICD10 = {
  code: 'O36.0130',
  description: 'Maternal care for anti-D antibodies — third trimester.',
  keywords: ['Rh sensitization', 'anti-D', 'antibody', 'Rh negative', 'third trimester'],
}

export const o36_4xx0: ICD10 = {
  code: 'O36.4XX0',
  description: 'Maternal care for intrauterine death.',
  keywords: ['fetal demise', 'IUFD', 'stillbirth', 'no heartbeat', 'fetal death'],
}

export const o36_511: ICD10 = {
  code: 'O36.511',
  description: 'Maternal care for known or suspected placental insufficiency — first trimester.',
  keywords: ['placental insufficiency', 'IUGR', 'growth restriction', 'small baby'],
}

export const o36_512: ICD10 = {
  code: 'O36.512',
  description: 'Maternal care for known or suspected placental insufficiency — second trimester.',
  keywords: [
    'placental insufficiency',
    'IUGR',
    'growth restriction',
    'small baby',
    'second trimester',
  ],
  notes: 'Auto-suggest when IUGR concern documented.',
}

export const o36_513: ICD10 = {
  code: 'O36.513',
  description: 'Maternal care for known or suspected placental insufficiency — third trimester.',
  keywords: [
    'placental insufficiency',
    'IUGR',
    'growth restriction',
    'small baby',
    'third trimester',
  ],
}

export const o36_6210: ICD10 = {
  code: 'O36.6210',
  description: 'Maternal care for excessive fetal growth — first trimester.',
  keywords: ['large baby', 'macrosomia', 'LGA', 'big baby', 'first trimester'],
  notes: 'Auto-suggest when macrosomia or LGA documented.',
}

export const o36_6220: ICD10 = {
  code: 'O36.6220',
  description: 'Maternal care for excessive fetal growth — second trimester.',
  keywords: ['large baby', 'macrosomia', 'LGA', 'second trimester'],
}

export const o36_6230: ICD10 = {
  code: 'O36.6230',
  description: 'Maternal care for excessive fetal growth — third trimester.',
  keywords: ['large baby', 'macrosomia', 'LGA', 'third trimester'],
}

export const o36_8120: ICD10 = {
  code: 'O36.8120',
  description: 'Decreased fetal movements — second trimester.',
  keywords: [
    'decreased fetal movement',
    'DFM',
    'baby not moving',
    'kick counts low',
    'second trimester',
  ],
  notes: 'Auto-suggest when decreased fetal movement documented.',
}

export const o36_8130: ICD10 = {
  code: 'O36.8130',
  description: 'Decreased fetal movements — third trimester.',
  keywords: [
    'decreased fetal movement',
    'DFM',
    'baby not moving',
    'kick counts low',
    'third trimester',
  ],
  notes: 'Auto-suggest when decreased fetal movement documented.',
}

export const o41_00x0: ICD10 = {
  code: 'O41.00X0',
  description: 'Oligohydramnios — first trimester.',
  keywords: ['low fluid', 'oligohydramnios', 'AFI low', 'fluid low', 'first trimester'],
  notes: 'Auto-suggest when AFI <5 or SDP <2 flagged on US.',
}

export const o41_02x0: ICD10 = {
  code: 'O41.02X0',
  description: 'Oligohydramnios — second trimester.',
  keywords: ['low fluid', 'oligohydramnios', 'AFI low', 'second trimester'],
  notes: 'Auto-suggest when AFI <5 or SDP <2 flagged.',
}

export const o41_03x0: ICD10 = {
  code: 'O41.03X0',
  description: 'Oligohydramnios — third trimester.',
  keywords: ['low fluid', 'oligohydramnios', 'AFI low', 'third trimester'],
  notes: 'Auto-suggest when AFI <5 or SDP <2 flagged.',
}

export const o40_1xx0: ICD10 = {
  code: 'O40.1XX0',
  description: 'Polyhydramnios — first trimester.',
  keywords: ['too much fluid', 'polyhydramnios', 'AFI high', 'AFI elevated', 'first trimester'],
  notes: 'Auto-suggest when AFI >25 or SDP >8 flagged on US.',
}

export const o40_2xx0: ICD10 = {
  code: 'O40.2XX0',
  description: 'Polyhydramnios — second trimester.',
  keywords: ['too much fluid', 'polyhydramnios', 'AFI high', 'second trimester'],
}

export const o40_3xx0: ICD10 = {
  code: 'O40.3XX0',
  description: 'Polyhydramnios — third trimester.',
  keywords: ['too much fluid', 'polyhydramnios', 'AFI high', 'third trimester'],
}

// ─── CATEGORY 9 — Placental Conditions and Bleeding ──────────────────────────

export const o43_101: ICD10 = {
  code: 'O43.101',
  description: 'Placenta previa — complete, first trimester.',
  keywords: ['placenta previa', 'complete previa', 'low placenta', 'covering cervix'],
  notes: 'Auto-suggest when placenta previa documented on US.',
}

export const o43_102: ICD10 = {
  code: 'O43.102',
  description: 'Placenta previa — complete, second trimester.',
  keywords: ['placenta previa', 'complete previa', 'second trimester'],
}

export const o43_103: ICD10 = {
  code: 'O43.103',
  description: 'Placenta previa — complete, third trimester.',
  keywords: ['placenta previa', 'complete previa', 'third trimester'],
}

export const o43_111: ICD10 = {
  code: 'O43.111',
  description: 'Placenta previa with hemorrhage — first trimester.',
  keywords: ['placenta previa bleeding', 'previa hemorrhage'],
}

export const o44_01: ICD10 = {
  code: 'O44.01',
  description: 'Placenta previa without hemorrhage — second trimester.',
  keywords: ['low placenta', 'placenta previa', 'no bleeding', 'second trimester'],
}

export const o44_11: ICD10 = {
  code: 'O44.11',
  description: 'Placenta previa with hemorrhage — second trimester.',
  keywords: ['placenta previa', 'bleeding', 'hemorrhage', 'second trimester'],
}

export const o20_0: ICD10 = {
  code: 'O20.0',
  description: 'Threatened abortion.',
  keywords: ['bleeding first trimester', 'threatened miscarriage', 'spotting first trimester'],
  notes: 'Auto-suggest when first trimester bleeding documented.',
}

export const o20_8: ICD10 = {
  code: 'O20.8',
  description: 'Other hemorrhage in early pregnancy.',
  keywords: ['spotting', 'bleeding', 'first trimester', 'early pregnancy'],
}

export const o20_9: ICD10 = {
  code: 'O20.9',
  description: 'Hemorrhage in early pregnancy, unspecified.',
  keywords: ['bleeding', 'spotting', 'first trimester'],
}

export const o46_001: ICD10 = {
  code: 'O46.001',
  description: 'Antepartum hemorrhage — first trimester.',
  keywords: ['bleeding', 'antepartum hemorrhage', 'APH', 'first trimester'],
  notes: 'Auto-suggest when bleeding documented after first trimester.',
}

export const o46_002: ICD10 = {
  code: 'O46.002',
  description: 'Antepartum hemorrhage — second trimester.',
  keywords: ['bleeding', 'antepartum hemorrhage', 'APH', 'second trimester'],
}

export const o46_003: ICD10 = {
  code: 'O46.003',
  description: 'Antepartum hemorrhage — third trimester.',
  keywords: ['bleeding', 'antepartum hemorrhage', 'APH', 'third trimester'],
}

export const o43_211: ICD10 = {
  code: 'O43.211',
  description: 'Adherent placenta, accreta — first trimester.',
  keywords: ['placenta accreta', 'accreta', 'adherent placenta'],
}

// ─── CATEGORY 10 — Preterm Labor and Cervical Concerns ───────────────────────

export const o60_00: ICD10 = {
  code: 'O60.00',
  description: 'Preterm labor without delivery — unspecified trimester.',
  keywords: ['preterm labor', 'PTL', 'early labor', 'premature labor'],
  notes: 'Auto-suggest when preterm labor documented.',
}

export const o60_02: ICD10 = {
  code: 'O60.02',
  description: 'Preterm labor without delivery — second trimester.',
  keywords: ['preterm labor', 'PTL', 'early labor', 'second trimester'],
}

export const o60_03: ICD10 = {
  code: 'O60.03',
  description: 'Preterm labor without delivery — third trimester.',
  keywords: ['preterm labor', 'PTL', 'early labor', 'third trimester'],
}

export const o26_872: ICD10 = {
  code: 'O26.872',
  description: 'Cervical shortening — second trimester.',
  keywords: [
    'short cervix',
    'cervical length',
    'cervical shortening',
    'incompetent cervix',
    'second trimester',
  ],
  notes: 'Auto-suggest when short cervical length documented on US.',
}

export const o26_873: ICD10 = {
  code: 'O26.873',
  description: 'Cervical shortening — third trimester.',
  keywords: ['short cervix', 'cervical length', 'cervical shortening', 'third trimester'],
}

export const o34_3xx0: ICD10 = {
  code: 'O34.3XX0',
  description: 'Maternal care for cervical incompetence.',
  keywords: ['incompetent cervix', 'cerclage', 'cervical weakness'],
  notes: 'Auto-suggest when cerclage in place or cervical incompetence documented.',
}

export const o42_011: ICD10 = {
  code: 'O42.011',
  description:
    'Preterm premature rupture of membranes — onset of labor within 24 hours, second trimester.',
  keywords: ['PPROM', 'water broke early', 'ruptured membranes preterm', 'second trimester'],
  notes: 'Auto-suggest when PROM documented before 37w.',
}

export const o42_013: ICD10 = {
  code: 'O42.013',
  description: 'Preterm PROM — onset within 24 hours, third trimester.',
  keywords: ['PPROM', 'water broke early', 'ruptured membranes preterm', 'third trimester'],
}

// ─── CATEGORY 11 — Postpartum Conditions ─────────────────────────────────────

export const o90_0: ICD10 = {
  code: 'O90.0',
  description: 'Disruption of cesarean wound.',
  keywords: ['C-section wound', 'cesarean wound', 'surgical site'],
}

export const o90_1: ICD10 = {
  code: 'O90.1',
  description: 'Disruption of perineal obstetric wound.',
  keywords: ['perineal wound', 'laceration', 'episiotomy', 'wound dehiscence'],
  notes: 'Auto-suggest in postpartum context when wound issue documented.',
}

export const o90_2: ICD10 = {
  code: 'O90.2',
  description: 'Hematoma of obstetric wound.',
  keywords: ['hematoma', 'bruising', 'wound hematoma'],
}

export const o90_3: ICD10 = {
  code: 'O90.3',
  description: 'Peripartum cardiomyopathy.',
  keywords: ['cardiomyopathy', 'heart', 'cardiac postpartum'],
}

export const o90_4: ICD10 = {
  code: 'O90.4',
  description: 'Postpartum acute kidney failure.',
  keywords: ['kidney', 'renal failure', 'postpartum'],
}

export const o91_011: ICD10 = {
  code: 'O91.011',
  description: 'Infection of nipple — first few weeks.',
  keywords: ['mastitis', 'nipple infection', 'breastfeeding infection'],
}

export const o91_111: ICD10 = {
  code: 'O91.111',
  description: 'Abscess of breast — first few weeks.',
  keywords: ['breast abscess', 'mastitis', 'breastfeeding', 'abscess'],
}

export const o91_211: ICD10 = {
  code: 'O91.211',
  description: 'Nonpurulent mastitis — first few weeks.',
  keywords: ['mastitis', 'breast infection', 'engorgement', 'breastfeeding pain'],
  notes: 'Auto-suggest when mastitis documented postpartum.',
}

export const o92_01: ICD10 = {
  code: 'O92.01',
  description: 'Retracted nipple — first few weeks.',
  keywords: ['retracted nipple', 'breastfeeding difficulty', 'latch'],
}

export const o92_11: ICD10 = {
  code: 'O92.11',
  description: 'Cracked nipple — first few weeks.',
  keywords: ['cracked nipple', 'sore nipple', 'breastfeeding pain'],
}

export const o92_3: ICD10 = {
  code: 'O92.3',
  description: 'Other disorders of lactation.',
  keywords: ['lactation', 'milk supply', 'low milk', 'breastfeeding issue'],
}

export const o92_6: ICD10 = {
  code: 'O92.6',
  description: 'Suppressed lactation.',
  keywords: ['suppressed lactation', 'not breastfeeding', 'formula', 'weaning'],
}

export const f53_0: ICD10 = {
  code: 'F53.0',
  description: 'Postpartum depression.',
  keywords: ['PPD', 'postpartum depression', 'baby blues', 'postnatal depression'],
  notes: 'Auto-suggest when postpartum depression documented.',
}

export const f53_1: ICD10 = {
  code: 'F53.1',
  description: 'Postpartum psychosis.',
  keywords: ['postpartum psychosis', 'puerperal psychosis'],
}

export const o85: ICD10 = {
  code: 'O85',
  description: 'Puerperal sepsis.',
  keywords: ['sepsis', 'postpartum infection', 'puerperal fever', 'infection postpartum'],
  notes: 'Flag as high priority — prompt urgent documentation.',
}

export const o86_00: ICD10 = {
  code: 'O86.00',
  description: 'Infection of obstetric surgical wound, unspecified.',
  keywords: ['wound infection', 'C-section infection', 'perineal infection'],
}

export const o86_4: ICD10 = {
  code: 'O86.4',
  description: 'Pyrexia of unknown origin following delivery.',
  keywords: ['fever postpartum', 'postpartum fever', 'unknown fever'],
  notes: 'Auto-suggest when postpartum fever documented.',
}

export const o87_1: ICD10 = {
  code: 'O87.1',
  description: 'Deep phlebothrombosis in the puerperium.',
  keywords: ['DVT', 'blood clot', 'deep vein thrombosis', 'postpartum clot'],
}

export const o87_3: ICD10 = {
  code: 'O87.3',
  description: 'Cerebral venous thrombosis in the puerperium.',
  keywords: ['cerebral vein thrombosis', 'CVT', 'headache severe postpartum'],
}

export const o72_0: ICD10 = {
  code: 'O72.0',
  description: 'Third-stage hemorrhage.',
  keywords: ['postpartum hemorrhage', 'PPH', 'retained placenta'],
  notes: 'Auto-suggest when PPH documented.',
}

export const o72_1: ICD10 = {
  code: 'O72.1',
  description: 'Other immediate postpartum hemorrhage.',
  keywords: ['PPH', 'postpartum hemorrhage', 'bleeding after delivery'],
  notes: 'Auto-suggest when PPH documented.',
}

// ─── CATEGORY 12 — Social Determinants, Screening, and Administrative ────────

export const z23: ICD10 = {
  code: 'Z23',
  description: 'Encounter for immunization.',
  keywords: ['vaccine', 'vaccination', 'immunization', 'flu shot', 'Tdap'],
  notes: 'Use when vaccine administered or discussed.',
}

export const z71_3: ICD10 = {
  code: 'Z71.3',
  description: 'Dietary counseling and surveillance.',
  keywords: ['nutrition counseling', 'diet', 'iron', 'folate', 'prenatal vitamins'],
  notes: 'Secondary code for nutrition counseling documented.',
}

export const z13_88: ICD10 = {
  code: 'Z13.88',
  description: 'Encounter for screening for disorder due to exposure to contaminants.',
  keywords: ['lead screening', 'environmental exposure'],
  notes: 'Use when lead or environmental screening performed.',
}

export const z11_4: ICD10 = {
  code: 'Z11.4',
  description: 'Encounter for screening for human immunodeficiency virus.',
  keywords: ['HIV screening', 'HIV test'],
  notes: 'Use when HIV screening performed at routine visit.',
}

export const z11_3: ICD10 = {
  code: 'Z11.3',
  description:
    'Encounter for screening for infections with a predominantly sexual mode of transmission.',
  keywords: ['STI screening', 'STD screening', 'gonorrhea', 'chlamydia', 'syphilis screening'],
  notes: 'Use when STI screening panel ordered.',
}

export const z77_010: ICD10 = {
  code: 'Z77.010',
  description: 'Contact with and (suspected) exposure to arsenic.',
  keywords: ['environmental', 'toxin exposure'],
}

export const z59_0: ICD10 = {
  code: 'Z59.0',
  description: 'Homelessness.',
  keywords: ['housing instability', 'homeless', 'no stable housing'],
  notes: 'Social determinant — secondary code.',
}

export const z59_1: ICD10 = {
  code: 'Z59.1',
  description: 'Inadequate housing.',
  keywords: ['housing', 'unsafe housing', 'poor housing'],
  notes: 'Social determinant — secondary code.',
}

export const z63_0: ICD10 = {
  code: 'Z63.0',
  description: 'Problems in relationship with spouse or partner.',
  keywords: ['domestic violence', 'relationship', 'partner'],
  notes: 'Social determinant — secondary code.',
}

export const t74_11xa: ICD10 = {
  code: 'T74.11XA',
  description: 'Adult physical abuse, confirmed.',
  keywords: ['domestic violence', 'abuse', 'IPV', 'intimate partner violence'],
  notes: 'Use with extreme care. Requires documentation of confirmed abuse.',
}

export const z04_11: ICD10 = {
  code: 'Z04.11',
  description: 'Encounter for examination and observation following alleged adult rape.',
  keywords: ['assault', 'rape', 'sexual assault'],
}

export const z76_89: ICD10 = {
  code: 'Z76.89',
  description: 'Persons encountering health services in other specified circumstances.',
  keywords: ['birth plan consult', 'pre-conception visit', 'general consultation'],
  notes: 'Use for miscellaneous visit types not captured elsewhere.',
}

export const z71_89: ICD10 = {
  code: 'Z71.89',
  description: 'Other specified counseling.',
  keywords: ['counseling', 'health education', 'anticipatory guidance'],
  notes: 'Secondary code when counseling is a primary activity of visit.',
}

// ─── GROUPS ───────────────────────────────────────────────────────────────────

export const routinePregnancySupervisionGroup: ICD10Group = {
  name: 'Routine Pregnancy Supervision',
  codes: [z34_01, z34_02, z34_03, z34_00, z34_90, z34_80, z09, z3a_40],
}

export const hypertensiveDisordersGroup: ICD10Group = {
  name: 'Hypertensive Disorders of Pregnancy',
  codes: [
    o13_1,
    o13_2,
    o13_3,
    o14_02,
    o14_03,
    o14_12,
    o14_13,
    o14_22,
    o14_23,
    o10_012,
    o10_013,
    o16_1,
    o16_2,
    o16_3,
  ],
}

export const diabetesInPregnancyGroup: ICD10Group = {
  name: 'Diabetes in Pregnancy',
  codes: [o24_010, o24_012, o24_013, o24_110, o24_112, o24_113, o24_410, o24_414, o24_415, z83_3],
}

export const mentalHealthGroup: ICD10Group = {
  name: 'Mental Health Conditions in Pregnancy',
  codes: [o99_340, o99_342, o99_343, f32_0, f41_1, f43_10, z13_89],
}

export const infectionsGroup: ICD10Group = {
  name: 'Infections During Pregnancy',
  codes: [
    o23_40,
    o23_41,
    o23_42,
    o23_43,
    o86_11,
    o23_591,
    o99_611,
    o23_592,
    b37_3,
    n76_0,
    o98_011,
    o98_111,
    o98_311,
    o98_312,
    o98_313,
    o99_321,
    o99_322,
    o99_323,
    b34_9,
    j06_9,
  ],
}

export const giNauseaVomitingGroup: ICD10Group = {
  name: 'GI, Nausea, and Vomiting in Pregnancy',
  codes: [o21_0, o21_1, o21_2, o21_9, o26_611, o26_612, o26_613, k21_0, k21_9, k59_00],
}

export const musculoskeletalSkinGroup: ICD10Group = {
  name: 'Musculoskeletal and Skin Conditions in Pregnancy',
  codes: [o26_711, o26_712, o26_713, m54_5, o26_891, o26_892, o26_893, l29_9, o26_81],
}

export const fetalConcernsGroup: ICD10Group = {
  name: 'Fetal Concerns and Presentations',
  codes: [
    o32_1xx0,
    o32_2xx0,
    o32_9xx0,
    o36_0110,
    o36_0120,
    o36_0130,
    o36_0131,
    o36_0191,
    o36_4xx0,
    o36_511,
    o36_512,
    o36_513,
    o36_6210,
    o36_6220,
    o36_6230,
    o36_8120,
    o36_8130,
    o41_00x0,
    o41_02x0,
    o41_03x0,
    o40_1xx0,
    o40_2xx0,
    o40_3xx0,
  ],
}

export const placentalConditionsBleedingGroup: ICD10Group = {
  name: 'Placental Conditions and Bleeding',
  codes: [
    o43_101,
    o43_102,
    o43_103,
    o43_111,
    o44_01,
    o44_11,
    o20_0,
    o20_8,
    o20_9,
    o46_001,
    o46_002,
    o46_003,
    o43_211,
  ],
}

export const pretermLaborCervicalGroup: ICD10Group = {
  name: 'Preterm Labor and Cervical Concerns',
  codes: [o60_00, o60_02, o60_03, o26_872, o26_873, o34_3xx0, o42_011, o42_013],
}

export const postpartumConditionsGroup: ICD10Group = {
  name: 'Postpartum Conditions',
  codes: [
    o90_0,
    o90_1,
    o90_2,
    o90_3,
    o90_4,
    o91_011,
    o91_111,
    o91_211,
    o92_01,
    o92_11,
    o92_3,
    o92_6,
    f53_0,
    f53_1,
    o85,
    o86_00,
    o86_4,
    o87_1,
    o87_3,
    o72_0,
    o72_1,
    z39_1,
    z39_2,
  ],
}

export const socialDeterminantsScreeningGroup: ICD10Group = {
  name: 'Social Determinants, Screening, and Administrative',
  codes: [
    z23,
    z71_3,
    z13_88,
    z11_4,
    z11_51,
    z11_3,
    z77_010,
    z59_0,
    z59_1,
    z63_0,
    t74_11xa,
    z04_11,
    z76_89,
    z71_89,
  ],
}

export const icdCodeGroups: ICD10Group[] = [
  routinePregnancySupervisionGroup,
  hypertensiveDisordersGroup,
  diabetesInPregnancyGroup,
  mentalHealthGroup,
  infectionsGroup,
  giNauseaVomitingGroup,
  musculoskeletalSkinGroup,
  fetalConcernsGroup,
  placentalConditionsBleedingGroup,
  pretermLaborCervicalGroup,
  postpartumConditionsGroup,
  socialDeterminantsScreeningGroup,
]

export const pregnancyPrioritizedIcd10Groups: ICD10Group[] = [
  routinePregnancySupervisionGroup,
  hypertensiveDisordersGroup,
  diabetesInPregnancyGroup,
  mentalHealthGroup,
  infectionsGroup,
  giNauseaVomitingGroup,
  musculoskeletalSkinGroup,
  fetalConcernsGroup,
  placentalConditionsBleedingGroup,
  pretermLaborCervicalGroup,
  postpartumConditionsGroup,
  socialDeterminantsScreeningGroup,
]

// ─── LEGACY FLAT ARRAY ────────────────────────────────────────────────────────

export const icdCodes: ICD10[] = [
  o36_0131,
  o36_0191,
  o63_9,
  o80,
  o82,
  p92_6,
  z00_110,
  z00_111,
  z01_419,
  z11_51,
  z30_0,
  z30_430,
  z33_1,
  z34_80,
  z37_0,
  z37_2,
  z38_1,
  z38_30,
  z39_2,
  z39_1,
  z3a_40,
]

export const getBcbsIcd10 = (icd: ICD10): ICD10 => ({
  ...icd,
  prefix: 'BCBS',
})
